export const ADMINISTRATORS_FETCH_INIT = 'ADMINISTRATORS_FETCH_INIT';
export const ADMINISTRATORS_FETCH_SUCCESS = 'ADMINISTRATORS_FETCH_SUCCESS';
export const ADMINISTRATORS_FETCH_ERROR = 'ADMINISTRATORS_FETCH_ERROR';

export const ADMINISTRATORS_POST_INIT = 'ADMINISTRATORS_POST_INIT';
export const ADMINISTRATORS_POST_SUCCESS = 'ADMINISTRATORS_POST_SUCCESS';
export const ADMINISTRATORS_POST_ERROR = 'ADMINISTRATORS_POST_ERROR';

export const ADMINISTRATORS_RESET = 'ADMINISTRATORS_RESET';
